import { useEffect, useState, useContext } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { getSfaData } from "../utils/apis";
import { AuthContext } from "../context/AuthContext";
import VariantProgressList from "../components/Top/VariantProgressList";
import comingsoonbg from "../assests/images/comingsoonbg.svg";
import comingsoontext from "../assests/images/comingsoontext.svg";
import TargetProgressCard from "../components/Top/TargetProgressCard";

const Top = () => {
  const authContext = useContext(AuthContext);
  const token = localStorage.getItem("token") || authContext?.token || "";

  // Extract ContactId from JWT payload (used as account_id in BE)
  const contactId = (() => {
    try {
      if (!token) return null;
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload?.User?.ContactId || null;
    } catch {
      return null;
    }
  })();
  const [sfaData, setSfaData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!contactId) {
      setLoading(false);
      return;
    }

    const fetchSfaData = async () => {
      try {
        const response = await getSfaData(token, undefined, undefined, contactId);
        const data = response?.data ?? response;
        if (!data || !Array.isArray(data) || data.length === 0) {
          setSfaData(null);
        } else {
          setSfaData(data);
        }
      } catch (err: any) {
        setError(err.message || "Unknown error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchSfaData();
  }, [contactId]);
  const isMobileDevice =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  return (
    <Box sx={{ background: "#fff", p: 0, minHeight: "80vh", mb: isMobileDevice ? "100px" : 0, }}>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : !sfaData || sfaData.length === 0 ? (
        <Box
          sx={{
            textAlign: "center",
            height: "87vh",
            position: "relative",
            backgroundImage: `url(${comingsoonbg})`,
            backgroundSize: "100%",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <img src={comingsoontext} alt="Coming Soon" />
          </Box>
        </Box>
      ) : (
        <>
  {/* ALWAYS SHOW NORMAL UI */}
  <TargetProgressCard contactId={contactId} />
  <VariantProgressList contactId={contactId} />
</>

      )}
    </Box>
  );
};

export default Top;
